import { smoothScroll } from '@/js/utils/smoothScroll';
import { registerClickHandler } from '@/js/utils/eventDelegation';
import { toNumberOrUndefined } from '@/js/utils/type';

/**
 * スクロールハンドラを登録
 *
 * 統一されたイベント委譲システムを使用
 */
export function registerScrollHandler() {
    registerClickHandler({
        selector: 'a[data-scroll-target]',
        priority: 10, // 優先度を指定可能
        callback: (trigger, event) => {
            const target = trigger.getAttribute('data-scroll-target');
            if (!target) return;

            const preventDefault = trigger.getAttribute('data-scroll-prevent-default') !== 'false';
            if (preventDefault) event.preventDefault();

            const easing = trigger.getAttribute('data-scroll-easing') || undefined;
            const adjust = toNumberOrUndefined(trigger.getAttribute('data-scroll-adjust'));

            smoothScroll(target, easing, adjust);
        },
    });
}
